export default "__VITE_ASSET__0FuflYMJ__"